import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {NEAR_BLACK} from 'ui-library/Colors';

import {SampleDataProps} from '../SpreadsheetBulkImportConstants';

export default function ChemicalStructureSaltsSampleData(props: SampleDataProps): JSX.Element {
  return (
    <div>
      <span className={css(styles.derivedValue)}>{props.derivedValue}</span>
      <br />
    </div>
  );
}

const styles = StyleSheet.create({
  derivedValue: {
    color: NEAR_BLACK,
    fontWeight: 'bold',
  },
});
